import { SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

export enum TriageToolbarButtonType {
  CreateException = "create-exception",
  RemoveException = "remove-exception",
  CreateTicket = "create-ticket",
  SetOutOfScope = "set-out-of-scope",
  SetInScope = "set-in-scope",
  Delete = "delete",
  CreateRemediationWorkflow = "create-remediation-workflow",
}

export interface TriageToolbarButtonConfig {
  type: TriageToolbarButtonType; // type to determine which exactly button to render
  label?: string; // optional label override
  tooltip?: string; // might have additional tooltip
  onClick?: () => void;
  disabled?: boolean;
  sx?: SxProps<Theme>; // custom button props override
}

export interface TriageToolbarPayload {
  count?: number;
  totalCount?: number;
  onClose?: () => void | undefined;
}

export interface ShowTriageToolbarOptions {
  buttons?: TriageToolbarButtonConfig[];
  content?: ReactNode;
  payload?: TriageToolbarPayload;
}
